import {
  withGetFragmentTable,
  withInsertFragmentTable,
  withInsertTextTable,
  withNormalizeTable,
  withSelectionTable,
  withDeleteTable,
  withSetFragmentDataTable,
} from '@udecode/plate-table';

import { withNormalizeUnbalancedTables } from './withNormalizeUnbalancedTables';
import { withNormalizeTableNodeIds } from './withNormalizeTableNodeIds';
import { withNormalizeTable2 } from './withNormalizeTable2';


export const withTable = (
  editor,
  plugin,
) => {
  let _editor = editor;
  _editor = withNormalizeTable(editor);
  _editor = withNormalizeTable2(editor);
  _editor = withDeleteTable(editor);
  _editor = withGetFragmentTable(editor, plugin);
  _editor = withInsertFragmentTable(editor, plugin);
  _editor = withInsertTextTable(editor, plugin);
  _editor = withSelectionTable(editor);
  _editor = withSetFragmentDataTable(editor);
  _editor = withNormalizeUnbalancedTables(editor);
  _editor = withNormalizeTableNodeIds(editor);

  return _editor;
};
